import { clientConfig } from '@/config/client';

const { timingApiHost } = clientConfig;

const timingApiUrl = `${timingApiHost}timings`;

type TimingsPayload = {
    contentGroupUuid: string;
    profileId: number;
    videoToken: string;
    authorizationToken: string;
    time: number;
    serialContentGroupUuid?: string;
};

export function sendTimings({ authorizationToken, ...timingsPayload }: TimingsPayload) {
    const body = JSON.stringify(timingsPayload);
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };

    if (authorizationToken) {
        headers['X-Timing-Token'] = authorizationToken;
    }

    return fetch(timingApiUrl, {
        body,
        headers,
        method: 'POST',
    })
        .then((response) => ({ status: response.status }))
        .catch((error) => ({ status: error.status, data: error }));
}
